import React from 'react';
import Application from './src/index';

export default function App() {
  return (
    <Application />
  );
}
